/* tslint:disable */

declare var Object: any;
export interface ERPproductionInterface {
  "id"?: number;
}

export class ERPproduction implements ERPproductionInterface {
  "id": number;
  constructor(data?: ERPproductionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPproduction`.
   */
  public static getModelName() {
    return "ERPproduction";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPproduction for dynamic purposes.
  **/
  public static factory(data: ERPproductionInterface): ERPproduction{
    return new ERPproduction(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPproduction',
      plural: 'ERPproductions',
      path: 'ERPproductions',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPproduction.ts